// extracted by mini-css-extract-plugin
export default {"base":"StateHeatMapNew_base__hhdDb","map_container":"StateHeatMapNew_map_container__9UzCJ"};